import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'contain' as const,
  },
  container: (props: { height: number; maxWidth: number }) => ({
    height: props.height,
    maxWidth: props.maxWidth,
  }),
});

interface Props {
  logo: string;
}

const PartnerIcon: React.FC<Props> = ({ logo }) => {
  const classes = useStyles({ height: 34, maxWidth: 140 });
  return (
    <div className={classes.container}>
      <img src={logo} className={classes.img} alt="" />
    </div>
  );
};

export default PartnerIcon;
